import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const ImageContainer = styled.div.attrs({
  role: 'button',
})`
  position: relative;
  width: 150px;
  height: 150px;
  margin: 10px;
  background-color: ${colors.lightContentGrey};
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;
